<div class="container mx-auto px-4 py-6">
  <!-- Loading spinner -->
  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <div class="flex items-center gap-3">
      <svg class="animate-spin h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <span class="text-gray-600">Cargando información del excedente...</span>
    </div>
  </div>

  <!-- Content -->
  <div *ngIf="!loading && excessPayment" class="space-y-6">
    
    <!-- Header -->
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <button 
          (click)="goBack()"
          class="inline-flex items-center text-blue-600 hover:text-blue-800 mb-3 transition duration-200">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
          Volver a excedentes
        </button>
        <h1 class="text-3xl font-bold text-gray-900 flex items-center">
          <i class="fas fa-chart-line mr-3 text-blue-600"></i>
          Resumen Financiero del Excedente
        </h1>
        <p class="text-gray-600 mt-1">
          Excedente ID: {{ excessPayment.id }} | 
          Creado: {{ formatDate(excessPayment.createdAt) }}
        </p>
      </div>
      
    </div>

    <!-- Loading Financial Summary -->
    <div *ngIf="loadingFinancialSummary" class="bg-white rounded-lg shadow-sm border p-8">
      <div class="flex justify-center items-center">
        <div class="flex items-center gap-3">
          <svg class="animate-spin h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="text-gray-600">Cargando resumen financiero...</span>
        </div>
      </div>
    </div>

    <!-- Financial Summary Content -->
    <div *ngIf="!loadingFinancialSummary && paymentGroupSummary" class="space-y-6">
      
      <!-- Información General -->
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-6 shadow-sm">
            <h4 class="font-semibold text-blue-800 mb-4 text-lg flex items-center">
              <i class="fas fa-money-bill-wave mr-2"></i>
              Información General del Pago
            </h4>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div>
            <span class="font-medium text-blue-700 block">Fecha del Pago:</span>
            <span class="text-gray-900">{{ formatDate(paymentGroupSummary.paymentDate) }}</span>
          </div>
          <div>
            <span class="font-medium text-blue-700 block">ID del Grupo:</span>
            <span class="font-mono text-sm text-gray-600">{{ paymentGroupSummary.paymentGroupId }}</span>
          </div>
          <div class="lg:col-span-1 md:col-span-2">
            <span class="font-medium text-blue-700 block">Concepto:</span>
            <span class="text-gray-900">{{ paymentGroupSummary.originalConcept }}</span>
          </div>
        </div>
      </div>

      <!-- Información del Estudiante y Programa -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        
        <!-- Información del Estudiante -->
        <div class="bg-purple-50 border border-purple-200 rounded-lg p-6 shadow-sm">
          <div class="flex items-center justify-between mb-4">
            <h4 class="font-semibold text-purple-800 text-lg flex items-center">
              <i class="fas fa-user-graduate text-purple-600 mr-2"></i>
              Información del Estudiante
            </h4>
            <a *ngIf="excessPayment.participant" [routerLink]="['/participants/profile-participant', excessPayment.participant.id]" 
               target="_blank"
               class="inline-flex items-center px-3 py-1.5 bg-purple-100 hover:bg-purple-200 text-purple-700 rounded-lg text-sm font-medium transition-colors duration-200">
              <i class="fas fa-user-circle mr-1"></i>
              Ver Perfil
            </a>
            <span *ngIf="excessPayment.company" class="text-purple-700 font-medium">
              <i class="fas fa-building mr-1"></i>
              Pago Corporativo: {{ excessPayment.company.name }}
            </span>
          </div>
          
          <div class="space-y-4">
            <!-- Nombre completo -->
            <div class="bg-white rounded-lg p-4 border border-purple-100">
              <div class="flex items-center mb-2">
                <svg class="w-5 h-5 text-purple-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <span class="font-medium text-purple-700">Nombre Completo</span>
              </div>
              <p class="text-lg font-semibold text-gray-900">
                {{ getPayerName(excessPayment) }}
              </p>
            </div>

            <!-- Documento de identificación -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <span class="font-medium text-purple-700 block text-sm">Tipo de Documento:</span>
                <span *ngIf="excessPayment.participant" class="text-gray-900">{{ excessPayment.participant.typeDocument }}</span>
                <span *ngIf="excessPayment.company" class="text-gray-900">{{ excessPayment.company.typeDocument }}</span>
              </div>
              <div>
                <span class="font-medium text-purple-700 block text-sm">Número de Documento:</span>
                <span class="text-gray-900 font-mono">{{ getPayerDocumentId(excessPayment) }}</span>
              </div>
            </div>

            <!-- Información de contacto -->
            <div class="space-y-2">
              <div *ngIf="excessPayment.participant" class="flex items-center">
                <svg class="w-4 h-4 text-purple-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"/>
                </svg>
                <span class="text-sm text-gray-700">{{ excessPayment.participant.email }}</span>
              </div>
              <div *ngIf="excessPayment.company" class="flex items-center">
                <svg class="w-4 h-4 text-purple-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"/>
                </svg>
                <span class="text-sm text-gray-700">{{ excessPayment.company.email }}</span>
              </div>
              <div *ngIf="excessPayment.participant" class="flex items-center">
                <svg class="w-4 h-4 text-purple-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                <span class="text-sm text-gray-700">{{ excessPayment.participant.cellPhone }}</span>
              </div>
              <div *ngIf="excessPayment.company" class="flex items-center">
                <svg class="w-4 h-4 text-purple-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                <span class="text-sm text-gray-700">{{ excessPayment.company.phone }}</span>
              </div>
            </div>

            <!-- Información adicional -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div *ngIf="excessPayment.participant?.age">
                <span class="font-medium text-purple-700 block">Edad:</span>
                <span class="text-gray-700">{{ excessPayment.participant?.age }} años</span>
              </div>
              <div *ngIf="excessPayment.participant?.profession">
                <span class="font-medium text-purple-700 block">Profesión:</span>
                <span class="text-gray-700">{{ excessPayment.participant?.profession }}</span>
              </div>
              <div *ngIf="excessPayment.participant?.city">
                <span class="font-medium text-purple-700 block">Ciudad:</span>
                <span class="text-gray-700">{{ excessPayment.participant?.city }}, {{ excessPayment.participant?.country }}</span>
              </div>
              <div *ngIf="excessPayment.company?.city">
                <span class="font-medium text-purple-700 block">Ciudad Empresa:</span>
                <span class="text-gray-700">{{ excessPayment.company?.city }}, {{ excessPayment.company?.country }}</span>
              </div>
              <div *ngIf="excessPayment.participant">
                <span class="font-medium text-purple-700 block">Estado:</span>
                <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                      [ngClass]="getParticipantStatusClass(excessPayment.participant.status.toString())">
                  {{ excessPayment.participant.status }}
                </span>
              </div>
              <div *ngIf="excessPayment.company">
                <span class="font-medium text-purple-700 block">Tipo de Pago:</span>
                <span class="text-purple-700 font-medium">
                  {{ getPayerType(excessPayment) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Información del Programa/Proyecto -->
        <div class="bg-indigo-50 border border-indigo-200 rounded-lg p-6 shadow-sm">
          <div class="flex items-center justify-between mb-4">
            <h4 class="font-semibold text-indigo-800 text-lg flex items-center">
              <i class="fas fa-graduation-cap text-indigo-600 mr-2"></i>
              Información del Programa
            </h4>
            <div class="flex items-center space-x-2">
              <a [routerLink]="getEnrollmentRoute()" 
                 target="_blank"
                 class="inline-flex items-center px-3 py-1.5 bg-teal-100 hover:bg-teal-200 text-teal-700 rounded-lg text-sm font-medium transition-colors duration-200">
                <i class="fas fa-file-contract mr-1"></i>
                Ver Inscripción
              </a>
              <a [routerLink]="['/projects/view-project', excessPayment.project.id]" 
                 target="_blank"
                 class="inline-flex items-center px-3 py-1.5 bg-indigo-100 hover:bg-indigo-200 text-indigo-700 rounded-lg text-sm font-medium transition-colors duration-200">
                <i class="fas fa-project-diagram mr-1"></i>
                Ver Proyecto
              </a>
            </div>
          </div>
          
          <div class="space-y-4">
            <!-- Nombre del programa -->
            <div class="bg-white rounded-lg p-4 border border-indigo-100">
              <div class="flex items-center mb-2">
                <svg class="w-5 h-5 text-indigo-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
                </svg>
                <span class="font-medium text-indigo-700">Nombre del Programa</span>
              </div>
              <p class="text-lg font-semibold text-gray-900">
                {{ excessPayment.project.name }}
              </p>
            </div>

            <!-- Detalles del programa -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <span class="font-medium text-indigo-700 block text-sm">Código del Programa:</span>
                <span class="text-gray-900 font-mono text-lg">{{ excessPayment.project.projectId }}</span>
              </div>
              <div>
                <span class="font-medium text-indigo-700 block text-sm">Tipo de Programa:</span>
                <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                      [ngClass]="getProjectTypeClass(excessPayment.project.typeProject)">
                  {{ excessPayment.project.typeProject }}
                </span>
              </div>
            </div>

            <!-- Información financiera del programa -->
            <div class="bg-indigo-25 rounded-lg p-3 border border-indigo-100">
              <h5 class="font-medium text-indigo-700 mb-2 text-sm flex items-center">
                <i class="fas fa-money-bill-wave mr-2"></i>
                Información Financiera del Programa
              </h5>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                <div>
                  <span class="font-medium text-indigo-600 block">Valor Matrícula (COP):</span>
                  <span class="text-gray-900 font-semibold">{{ formatCurrency(excessPayment.project.inscriptionAmountCOP, 'COP') }}</span>
                </div>
                <!-- <div *ngIf="excessPayment.project.inscriptionAmountUSD">
                  <span class="font-medium text-indigo-600 block">Valor Matrícula (USD):</span>
                  <span class="text-gray-900 font-semibold">{{ formatCurrency(excessPayment.project.inscriptionAmountUSD, 'USD') }}</span>
                </div> -->
                <div>
                  <span class="font-medium text-indigo-600 block">Duración:</span>
                  <span class="text-gray-700">{{ excessPayment.project.duration }} {{ excessPayment.project.duration === 1 ? 'semana' : 'semanas' }}</span>
                </div>
                <div>
                  <span class="font-medium text-indigo-600 block">Estado del Programa:</span>
                  <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                        [ngClass]="getProjectStatusClass(excessPayment.project.status)">
                    {{ excessPayment.project.status }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Información de matrícula -->
            <div class="space-y-2">
              <div class="flex items-center justify-between text-sm" *ngIf="excessPayment.enrollment">
                <span class="font-medium text-indigo-700">ID de Matrícula:</span>
                <span class="text-gray-700 font-mono">#{{ excessPayment.enrollment.id }}</span>
              </div>
              <div class="flex items-center justify-between text-sm" *ngIf="excessPayment.corporateEnrollment">
                <span class="font-medium text-indigo-700">ID de Matrícula Corporativa:</span>
                <span class="text-gray-700 font-mono">#{{ excessPayment.corporateEnrollment.id }}</span>
              </div>
              <div class="flex items-center justify-between text-sm">
                <span class="font-medium text-indigo-700">Moneda:</span>
                <span class="text-gray-700">{{ getCurrencyCode(excessPayment) }}</span>
              </div>
              <div class="flex items-center justify-between text-sm" *ngIf="excessPayment.enrollment?.exchangeRateUsed">
                <span class="font-medium text-indigo-700">Tasa de Cambio Usada:</span>
                <span class="text-gray-700">{{ excessPayment.enrollment?.exchangeRateUsed | number:'1.2-4' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Resumen de Montos -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <!-- Monto Total Recibido -->
        <div class="bg-green-50 border border-green-200 rounded-lg p-6 text-center shadow-sm">
          <div class="mb-3">
            <i class="fas fa-dollar-sign text-3xl text-green-600"></i>
          </div>
          <h5 class="font-semibold text-green-800 text-lg">Total Recibido</h5>
          <p class="text-2xl font-bold text-green-700 mt-2">{{ formatCurrency(paymentGroupSummary.totalReceivedAmount, paymentGroupSummary.currencyCode) }}</p>
          <p class="text-sm text-green-600 mt-1">Monto original del pago</p>
        </div>

        <!-- Monto Aplicado a Cuotas -->
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center shadow-sm">
          <div class="mb-3">
            <i class="fas fa-file-alt text-3xl text-blue-600"></i>
          </div>
          <h5 class="font-semibold text-blue-800 text-lg">Aplicado a Cuotas</h5>
          <p class="text-2xl font-bold text-blue-700 mt-2">{{ formatCurrency(paymentGroupSummary.totalAppliedAmount, paymentGroupSummary.currencyCode) }}</p>
          <p class="text-sm text-blue-600 mt-1">{{ paymentGroupSummary.installmentsPaid }} cuota(s) pagada(s)</p>
        </div>

        <!-- Excedente Generado -->
        <div class="bg-orange-50 border border-orange-200 rounded-lg p-6 text-center shadow-sm">
          <div class="mb-3">
            <i class="fas fa-balance-scale text-3xl text-orange-600"></i>
          </div>
          <h5 class="font-semibold text-orange-800 text-lg">Excedente</h5>
          <p class="text-2xl font-bold text-orange-700 mt-2">{{ formatCurrency(paymentGroupSummary.totalExcessAmount, paymentGroupSummary.currencyCode) }}</p>
          <p class="text-sm text-orange-600 mt-1">Monto disponible</p>
        </div>
      </div>

      <!-- Flujo Visual del Dinero -->
      <div class="bg-white border border-gray-300 rounded-lg p-6 shadow-sm">
        <h4 class="font-semibold text-gray-800 mb-6 text-lg flex items-center">
          <i class="fas fa-sync-alt text-gray-600 mr-2"></i>
          Flujo del Dinero
        </h4>
        <div class="flex items-center justify-center space-x-6 text-sm">
          
          <!-- Pago Recibido -->
          <div class="text-center">
            <div class="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center text-green-600 mb-3 mx-auto shadow-sm">
              <i class="fas fa-credit-card text-2xl"></i>
            </div>
            <p class="font-medium text-gray-700">Pago Recibido</p>
            <p class="text-green-600 font-bold">{{ formatCurrency(paymentGroupSummary.totalReceivedAmount, paymentGroupSummary.currencyCode) }}</p>
          </div>

          <!-- Flecha -->
          <div class="text-gray-400">
            <i class="fas fa-arrow-right text-2xl"></i>
          </div>

          <!-- Aplicado a Cuotas -->
          <div class="text-center">
            <div class="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mb-3 mx-auto shadow-sm">
              <i class="fas fa-file-invoice text-2xl"></i>
            </div>
            <p class="font-medium text-gray-700">Aplicado a Cuotas</p>
            <p class="text-blue-600 font-bold">{{ formatCurrency(paymentGroupSummary.totalAppliedAmount, paymentGroupSummary.currencyCode) }}</p>
          </div>

          <!-- Flecha -->
          <div class="text-gray-400" *ngIf="paymentGroupSummary.totalExcessAmount > 0">
            <i class="fas fa-arrow-right text-2xl"></i>
          </div>

          <!-- Excedente -->
          <div class="text-center" *ngIf="paymentGroupSummary.totalExcessAmount > 0">
            <div class="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center text-orange-600 mb-3 mx-auto shadow-sm">
              <i class="fas fa-balance-scale text-2xl"></i>
            </div>
            <p class="font-medium text-gray-700">Excedente</p>
            <p class="text-orange-600 font-bold">{{ formatCurrency(paymentGroupSummary.totalExcessAmount, paymentGroupSummary.currencyCode) }}</p>
          </div>
        </div>
      </div>

      <!-- Detalle de Cuotas Pagadas -->
      <div class="bg-gray-50 border border-gray-200 rounded-lg p-6 shadow-sm">
        <h4 class="font-semibold text-gray-800 mb-4 text-lg flex items-center">
          <i class="fas fa-clipboard-list text-gray-600 mr-2"></i>
          Detalle de Cuotas Pagadas
        </h4>
        <div class="overflow-x-auto">
          <table class="min-w-full bg-white rounded-lg overflow-hidden">
            <thead class="bg-gray-100">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cuota #</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Concepto</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
              <tr *ngFor="let receipt of paymentGroupSummary.incomeReceipts" class="hover:bg-gray-50">
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  <span class="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-semibold">
                    Cuota {{ receipt.installmentNumber }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {{ formatCurrency(receipt.grossAmount, paymentGroupSummary.currencyCode) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
                        [ngClass]="getPaymentStatusClass(receipt.paymentPlanStatus)">
                    {{ receipt.paymentPlanStatus }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                  {{ formatDate(receipt.createdAt) }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-900">
                  {{ receipt.concept }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <a [routerLink]="['/income-receipts/view', receipt.id]" 
                     target="_blank"
                     class="inline-flex items-center px-3 py-1.5 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-lg text-sm font-medium transition-colors duration-200">
                    <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-10a2 2 0 00-2-2h-4M14 4v4a2 2 0 01-2 2H8a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2z"/>
                    </svg>
                    Ver Comprobante
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Información del Excedente -->
      <div *ngIf="paymentGroupSummary.excessPayment" class="bg-yellow-50 border border-yellow-200 rounded-lg p-6 shadow-sm">
        <h4 class="font-semibold text-yellow-800 mb-4 text-lg flex items-center">
          <i class="fas fa-exclamation-triangle text-yellow-600 mr-2"></i>
          Estado Actual del Excedente
        </h4>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div>
            <span class="font-medium text-yellow-700 block">Monto Disponible:</span>
            <span class="text-lg font-bold text-green-600">{{ formatCurrency(paymentGroupSummary.excessPayment.availableAmount, paymentGroupSummary.currencyCode) }}</span>
          </div>
          <div>
            <span class="font-medium text-yellow-700 block">Monto Utilizado:</span>
            <span class="text-lg font-bold text-red-600">{{ formatCurrency(paymentGroupSummary.excessPayment.usedAmount, paymentGroupSummary.currencyCode) }}</span>
          </div>
          <div>
            <span class="font-medium text-yellow-700 block">Estado:</span>
            <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium"
                  [ngClass]="getStatusClass(paymentGroupSummary.excessPayment.status)">
              {{ paymentGroupSummary.excessPayment.status }}
            </span>
          </div>
          <div *ngIf="paymentGroupSummary.excessPayment.expirationDate">
            <span class="font-medium text-yellow-700 block">Fecha de Expiración:</span>
            <span class="text-sm text-gray-700">{{ formatDate(paymentGroupSummary.excessPayment.expirationDate) }}</span>
          </div>
        </div>

        <!-- Alertas de estado -->
        <div class="mt-4">
          <div *ngIf="paymentGroupSummary.excessPayment.isExpired" class="bg-red-100 border border-red-300 text-red-700 px-4 py-3 rounded-lg flex items-center">
            <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
            <span class="font-medium">Este excedente ha expirado y ya no puede ser utilizado.</span>
          </div>
          
          <div *ngIf="!paymentGroupSummary.excessPayment.isExpired && paymentGroupSummary.excessPayment.availableAmount > 0" class="bg-green-100 border border-green-300 text-green-700 px-4 py-3 rounded-lg flex items-center">
            <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
            </svg>
            <span class="font-medium">Este excedente está disponible para ser utilizado.</span>
          </div>
        </div>
      </div>

    </div>

    <!-- Basic Info if no payment group summary -->
    <div *ngIf="!loadingFinancialSummary && !paymentGroupSummary" class="bg-white rounded-lg shadow-sm border p-6">
      <div class="text-center">
        <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
        </svg>
        <h3 class="mt-2 text-sm font-medium text-gray-900">Información limitada disponible</h3>
        <p class="mt-1 text-sm text-gray-500">No se pudo cargar el resumen financiero completo para este excedente.</p>
        
        <!-- Información básica del excedente -->
        <div class="mt-6 bg-gray-50 rounded-lg p-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
            <div>
              <span class="block text-sm font-medium text-gray-700">Monto del Excedente:</span>
              <span class="text-lg font-semibold text-gray-900">{{ formatCurrency(excessPayment.excessAmount, excessPayment.enrollment?.currencyCode) }}</span>
            </div>
            <div>
              <span class="block text-sm font-medium text-gray-700">Estado:</span>
              <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium" [ngClass]="getStatusClass(excessPayment.status)">
                {{ excessPayment.statusDescription }}
              </span>
            </div>
            <div>
              <span class="block text-sm font-medium text-gray-700">Participante:</span>
              <span class="text-sm text-gray-900">{{ getPayerName(excessPayment) }}</span>
            </div>
            <div>
              <span class="block text-sm font-medium text-gray-700">Proyecto:</span>
              <span class="text-sm text-gray-900">{{ excessPayment.project.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Error state -->
  <div *ngIf="!loading && !excessPayment" class="text-center py-12">
    <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
    </svg>
    <h3 class="mt-2 text-sm font-medium text-gray-900">Excedente no encontrado</h3>
    <p class="mt-1 text-sm text-gray-500">El excedente solicitado no existe o no tienes permisos para verlo.</p>
    <div class="mt-6">
      <button 
        (click)="goBack()"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
        Volver a excedentes
      </button>
    </div>
  </div>
</div>